export default {
  ROOT: "/",
  LOGIN: "/login",
  PROPOSALS: "/propostas",
};
